<template>
  <div class="container">
    <header>
      <h1 class="title">国网能源研究院<br>能源需求预测平台</h1>
      <p class="subtitle">智能分析 · 精准预测 · 科学决策</p>
      <div class="header-decoration"></div>
    </header>

    <div class="card-container">
      <div class="card" v-for="(item, index) in menuItems" 
           :key="item.path"
           :style="{ animationDelay: `${index * 0.2}s` }">
        <div class="card-content">
          <div class="icon-wrapper">
            <i :class="['card-icon', 'fas', item.icon]"></i>
          </div>
          <button class="btn" @click="navigateTo(item)">
            <span>{{ item.title }}</span>
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      menuItems: [
        { title: '全国能源供需', icon: 'fa-globe-asia', path: '/national', external: false },
        { title: '分省能源供需', icon: 'fa-map-marked-alt', path: '/provincial', external: false }
      ]
    }
  },
  methods: {
    navigateTo(item) {
      if (item.external) {
        window.open(item.path, '_blank');
      } else {
        this.$router.push(item.path);
      }
    }
  }
}
</script>

<style scoped>
.container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  max-width: 800px;
}

.title {
  font-size: 56px;
  background: linear-gradient(45deg, #2c3e50, #3498db, #2c3e50);
  background-size: 200% auto;
  animation: gradient 3s ease infinite;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.subtitle {
  font-size: 24px;
  color: #5a6d7e;
  letter-spacing: 2px;
  position: relative;
  display: inline-block;
}

.header-decoration {
  width: 120px;
  height: 5px;
  background: linear-gradient(90deg, #3498db, #2c3e50);
  margin: 35px auto 0;
  border-radius: 3px;
}

.card-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.card {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border-radius: 20px;
  animation: fadeInUp 0.6s ease-out forwards;
  opacity: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 100%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 220px;
  width: 100%;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 40px 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  gap: 25px;
}

.icon-wrapper {
  width: 110px;
  height: 110px;
  margin-bottom: 0;
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.card:hover .icon-wrapper {
  transform: scale(1.1);
}

.card-icon {
  font-size: 48px;
  color: #1890ff;
  background: linear-gradient(135deg, #1890ff, #096dd9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.btn {
  padding: 20px 30px;
  font-size: 24px;
  margin-top: auto;
  width: 85%;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: white;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(24, 144, 255, 0.3);
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: 0.5s;
}

.btn:hover::before {
  left: 100%;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes gradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@media (max-width: 768px) {
  .container {
    padding: 30px 15px;
    justify-content: flex-start;
  }
  
  .header {
    margin-bottom: 30px;
  }
  
  .title {
    font-size: 42px;
  }
  
  .subtitle {
    font-size: 20px;
  }
  
  .card-container {
    grid-template-columns: 1fr;
    max-width: 400px;
    gap: 25px;
  }
  
  .card {
    min-height: 200px;
  }
  
  .card-content {
    padding: 30px 20px;
    gap: 20px;
  }
  
  .icon-wrapper {
    width: 100px;
    height: 100px;
  }
  
  .card-icon {
    font-size: 40px;
  }
  
  .btn {
    font-size: 22px;
    padding: 18px 25px;
  }
}
</style>
